

















































































import {Component, Prop} from 'vue-property-decorator'
import {BridgeNetworks} from '@/model/bridge/types/BridgeNetworks'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {$} from '@/facade'
import BridgeInput from '@/components/BridgeInput.vue'
import BridgeTokenAccountBalance from '@/components/BridgeTokenAccountBalance.vue'

@Component({
  components: {
    BridgeTokenAccountBalance,
    BridgeInput,
  },
})
export default class BridgeSourceSection extends MixinScreenSize {
  @Prop({type: String, required: true}) network!: BridgeNetworks
  @Prop({type: String, required: true}) amount!: string
  @Prop({type: String, required: true}) maxAmount!: string
  @Prop({type: Number, required: true}) decimals!: number
  @Prop({type: Boolean, required: true}) isMaxAmountSelected!: boolean
  @Prop({type: Boolean, default: false}) balanceUnavailable!: boolean
  @Prop({type: String, default: ''}) balanceUnavailableMessage!: string

  get isConnected() {
    return this.network === 'N3'
      ? $.walletAdapter.n3ConnectedWalletPlatform
      : $.walletAdapter.xConnectedWalletPlatform
  }

  get tokenIcon() {
    return this.network === 'N3'
      ? require('@/assets/img/neo.svg')
      : require('@/assets/img/neox.svg')
  }

  get tokenAlt() {
    return this.network === 'N3' ? 'neo icon' : 'neo X icon'
  }

  get tokenLabel() {
    if (this.isMobile) {
      return this.network === 'N3'
        ? this.$translate('components.BridgePanel.neoN3Mobile')
        : this.$translate('components.BridgePanel.neoX')
    }

    return this.network === 'N3'
      ? this.$translate('components.BridgePanel.neoN3')
      : this.$translate('components.BridgePanel.neoX')
  }

  get tokenClass() {
    return this.network === 'N3' ? 'bg-white' : 'bg-black'
  }

  handleInput(amount: string) {
    this.$emit('input', amount)
  }

  handleConnectWallet() {
    this.$emit('connect')
  }

  handleMaxClick() {
    this.$emit('max')
  }
}
